import React, { useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import Tables from "./Tables";
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { materialDark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { Menu, Segment } from "semantic-ui-react";


import {
  Button,
  Modal,
} from "semantic-ui-react";

function TableVisualise({ show, closeModal, currentData }) {
  const [open, setOpen] = useState(true);
  const [displayChart, setDisplayChart] = useState(false);
  const [chartData, setChartData] = useState(null);
  const [chartOptions, setChartOptions] = useState(null);
  const [displayCode, setDisplayCode] = useState(false);


  useEffect( () => {
    var rowdata = currentData.tableData.data;
    var chartInfo = currentData.chartInfo;
    if("X" in chartInfo && "Y" in chartInfo) {
      var xlabel = chartInfo["X"]
      var ylabel = chartInfo["Y"]
      if(typeof(xlabel) === "string" && typeof(ylabel) === "string") {
        var xydata = rowdata.map((element, index) => {return [element[xlabel], parseInt(element[ylabel])]});
        console.log(xydata);
  
        if(xydata.length > 0 && xydata[0] !== undefined && xydata[1] !== undefined && !Number.isNaN(xydata[1])) {
          setChartData([
            [xlabel, ylabel],
            ...xydata,
          ]);
          setChartOptions({
            title: currentData.displayInfo.question,
            backgroundColor: 'black',
            colors: ["#7e7e7e"],
            titleTextStyle: {
              color: "#aaaaaa",
            },
            legend: {
              textStyle: {
                color: '#aaaaaa'
              }
            },
            hAxis: {
              textStyle: {
                color: '#aaaaaa' // Set the color of the x-axis markings
              },
              gridlines: {
                count: 0,
              },
            },
            vAxis: {
              textStyle: {
                color: '#aaaaaa' // Set the color of the y-axis markings
              },
              gridlines: {
                color: '#4e4e4e', // Set the color of the vertical gridlines
                count: 2,
              },
            },
        
        
          });
          
          setDisplayChart(true);
        }
      } 
    }
  }, [currentData]);

  const displaysql = () => {
    setDisplayCode(!displayCode);
  }
  

  return (
    <Modal
      onClose={() => {setOpen(false); closeModal()}}
      onOpen={() => setOpen(true)}
      open={open}
    >
      {/* <Modal.Header>Preview</Modal.Header> */}
      <Modal.Content>
        <Modal.Description>
          {displayChart && 
            <>  
            <Chart
              chartType="LineChart"
              width="100%"
              height="400px"
              data={chartData}
              options={chartOptions}
            />
            <br/>
            </>
          }
          {currentData.tableData !== undefined && 

            <div>
              <Segment inverted className="question_label">{currentData.displayInfo["question"]}</Segment>
              <Menu borderless>
              {/* <Menu.Item onClick={()=>{}}>
                  <Icon name="history"/>
                </Menu.Item> */}
                <Menu.Item onClick={displaysql}>
                  <div>
                  <a href="#!">Click to view code</a>
                  </div>
                </Menu.Item>
                {/* <Menu.Item onClick={()=>{}}>
                  <Icon name="save" />
                </Menu.Item>
                <Menu.Item onClick={()=>{}}>
                  <Icon name="upload"/>
                </Menu.Item> */}
                </Menu>
                {displayCode &&
                  (<SyntaxHighlighter language="sql" style={materialDark}>
                      {currentData.displayInfo["query"]}
                  </SyntaxHighlighter>)
                }
              {currentData.tableData.headers.length > 0 && <Tables headers={currentData.tableData.headers} data={currentData.tableData.data}/>}
            </div>
          }
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button color="black" onClick={() => {setOpen(false); closeModal()}}>
          Close
        </Button>
      </Modal.Actions>
    </Modal>
  );
}

export default TableVisualise;
